import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { Looks6Rounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { WindTunnelStudyInput } from '@core/const'
import { WindTunnelStudyResponse } from '@/core/query'

export interface WindTunnelStudyHistory extends WindTunnelStudyInput {
  type: 'WindTunnelStudy',
  result: WindTunnelStudyResponse
}

interface Props {
  history: WindTunnelStudyHistory
}
function WindTunnelStudyHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  const resultString: string = history.result.isNeedTesting === 1 ? t('GLOSSARY.REQUIRED') : t('GLOSSARY.NOT_REQUIRED')

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <Looks6Rounded />
        <Box className="grid grid-cols-2 gap-8 min-w-[16rem] overflow-auto">
          <HistoryItemField
            label={t('GLOSSARY.OUTER_AREA')}
            unit="m2"
            value={history.outerArea}
          />
          <HistoryItemField
            label={t('GLOSSARY.HEIGHT')}
            unit="m"
            value={history.height}
          />
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <Box className="flex flex-col gap-8">
          <HistoryItemField
            label={t('GLOSSARY.WIND_TUNNEL_STUDY_CRITERIA')}
            value={history.result.criteria.toFixed(2)}
          />
          <HistoryItemField
            label={t('GLOSSARY.WIND_TUNNEL_STUDY_WHETHER')}
            value={resultString}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default WindTunnelStudyHistoryItem
